import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { UserForm } from '@/components/forms/UserForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditUserPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const numericId = id ? Number(id) : undefined

  const handleSuccess = () => {
    navigate('/user-management/users')
  }

  const handleCancel = () => {
    navigate('/user-management/users')
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Edit User
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Update user account details and role assignments
            </Text>
          </CardHeader>
          <CardBody>
            <UserForm userId={numericId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


